<template>
  <v-layout wrap fill-height>
    <v-flex xs12 pb-2 px-2>
      <div class="sidebar-filter-wrapper pa-5 rounded-xl border bg-white mb-6">
        <!-- Header -->
        <div class="d-flex align-center mb-4">
          <v-icon color="#3EA56E" class="mr-2">mdi-filter-variant</v-icon>
          <h3 class="filter-title">Filters</h3>
        </div>
        
        <v-divider class="mb-5"></v-divider>
        
        <!-- Search -->
        <div class="filter-section mb-6">
          <v-autocomplete
            :items="productList"
            hide-details
            @change="searchProduct()"
            outlined
            clearable
            class="custom-search-field"
            placeholder="Search products..."
            dense
            v-model="keyword"
            item-text="productname"
            item-id="_id"
            color="#3EA56E"
            prepend-inner-icon="mdi-magnify"
          ></v-autocomplete>
        </div>

        <!-- Availability -->
        <div class="filter-section mb-6">
          <h4 class="filter-subtitle mb-3">Availability</h4>
          <div class="checkbox-group">
            <v-checkbox
              v-model="checkbox1"
              @change="availability()"
              :label="'In Stock (' + navItem.inStock + ')'"
              hide-details
              color="#3EA56E"
              class="custom-checkbox mt-0 mb-2"
            ></v-checkbox>
            <v-checkbox
              v-model="checkbox2"
              @change="availability()"
              :label="'Out Of Stock (' + navItem.outOffstock + ')'"
              hide-details
              color="#3EA56E"
              class="custom-checkbox mt-0"
            ></v-checkbox>
          </div>
        </div>

        <v-divider class="mb-5"></v-divider>

        <!-- Price -->
        <div class="filter-section">
          <h4 class="filter-subtitle mb-3">Price Range</h4>
          <v-layout wrap>
            <v-flex xs6 pr-2>
              <v-text-field
                v-model="lowestprice"
                @change="availability()"
                hide-details
                label="Min (₹)"
                outlined
                dense
                color="#3EA56E"
                class="custom-price-field"
                type="number"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 pl-2>
              <v-text-field
                v-model="highestprice"
                @change="availability()"
                hide-details
                label="Max (₹)"
                outlined
                dense
                color="#3EA56E"
                class="custom-price-field"
                type="number"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </div>

        <!-- Reset Button -->
        <div class="mt-6 text-center">
          <v-btn
            outlined
            color="#ef4444"
            block
            class="rounded-lg"
            style="text-transform: none; font-family: 'ibmmedium', sans-serif;"
            @click="resetFilters"
          >
            Reset Filters
          </v-btn>
        </div>
      </div>
    </v-flex>
  </v-layout>
</template>
<script>

export default {
  props: ["navItem", "productList"],
  data() {
    return {
      checkbox1: false,
      checkbox2: false,
      lowestprice: null,
      highestprice: null,
      keyword1: null,
      keyword: null,
    };
  },
  computed: {
    appLogin() {
      return this.$store.state.isLoggedIn;
    },
  },
  watch: {
    searchItem() {
      console.log("searchitem=", this.searchItem);
    },
  },
  mounted() {
    console.log("item=", this.navItem);
    // console.log("searchitem=", this.searchItem);
  },
  methods: {
    resetFilters() {
      this.keyword = null;
      this.checkbox1 = false;
      this.checkbox2 = false;
      this.lowestprice = null;
      this.highestprice = null;
      
      this.searchProduct();
      this.availability();
    },
    availability() {
      {
        // if(this.checkbox1== true){
        //     this.checkbox2 = false
        // }
        // else if(this.checkbox1== false){
        //     this.checkbox1 = false
        // }
        // else if(this.checkbox2== true){
        //     this.checkbox1 = false
        // }
        // else if(this.checkbox2== true){
        //     this.checkbox1 = false
        // }
        // else{
        //     this.checkbox1 = false,
        //     this.checkbox2 = false
        // }
        this.$emit("stepper", {
          ref: "availability",
          instock: this.checkbox1,
          outstock: this.checkbox2,
          lowest: this.lowestprice,
          highest: this.highestprice,
          getdata: true,
        });
      }
    },
    searchProduct() {
      {
        console.log("search=hai", this.keyword);
        this.$emit("stepper", {
          ref: "search",
          keyword1: this.keyword,
          searchFun: true,
        });
      }
    },
  },
};
</script>

<style scoped>
.sidebar-filter-wrapper {
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
}

.filter-title {
  font-family: 'ibmsemibold', sans-serif;
  font-size: 20px;
  color: #1a202c;
  margin: 0;
}

.filter-subtitle {
  font-family: 'ibmmedium', sans-serif;
  font-size: 16px;
  color: #475569;
  margin: 0;
}

.custom-search-field >>> fieldset {
  border-radius: 12px;
  border-color: #e2e8f0;
}

.custom-price-field >>> fieldset {
  border-radius: 10px;
  border-color: #e2e8f0;
}

.custom-checkbox >>> .v-label {
  font-family: 'sofialight', sans-serif;
  font-size: 14px;
  color: #334155;
}

.border {
  border: 1px solid #e2e8f0 !important;
}

.bg-white {
  background-color: #ffffff !important;
}
</style>